import React from 'react';

const ConnectionLines = ({ yardBookings, yardPositions, calculateRampsPerRow }) => {
    const lines = [];

    yardBookings.forEach(booking => {
        booking.BOOKINGTASKS?.forEach(task => {
            if (task.STATUS === 1 && task.LOCATIONID && task.PENDING_LOCATIONID) {
                const parkingSlot = yardPositions.find(pos =>
                    pos.LOCATIONID === task.LOCATIONID && pos.LOCATIONTYPE === 2
                );
                const targetRamp = yardPositions.find(pos =>
                    pos.LOCATIONID === task.PENDING_LOCATIONID && pos.LOCATIONTYPE === 3
                );

                if (parkingSlot && targetRamp) {
                    const bookedParkingSlots = yardBookings
                        .flatMap(b => {
                            const tasks = b.BOOKINGTASKS || [];
                            const parkingTasks = tasks.filter(task => {
                                const location = yardPositions.find(pos => pos.LOCATIONID === task.LOCATIONID);
                                return location && location.LOCATIONTYPE === 2;
                            });

                            if (b.TRUCKTYPE === 2 && parkingTasks.length > 0) {
                                return parkingTasks.map(task => ({
                                    booking: b,
                                    task: task,
                                    ID: task.BOOKINGTASKID
                                }));
                            } else if (parkingTasks.length > 0) {
                                return [{
                                    booking: b,
                                    ID: b.BOOKINGID
                                }];
                            }
                            return [];
                        })
                        .filter(Boolean);

                    let displayedIndex = -1;
                    let slotRowIndex = 0;
                    let colIndex = 0;

                    if (bookedParkingSlots.length > 0) {
                        const halfIndex = Math.ceil(bookedParkingSlots.length / 2);
                        const firstRowItems = bookedParkingSlots.slice(0, halfIndex);
                        const firstRowTaskIndex = firstRowItems.findIndex(item => {
                            if (item.task) {
                                return item.task.BOOKINGTASKID === task.BOOKINGTASKID;
                            } else {
                                return item.booking.BOOKINGTASKS?.some(t => t.BOOKINGTASKID === task.BOOKINGTASKID);
                            }
                        });

                        if (firstRowTaskIndex !== -1) {
                            displayedIndex = firstRowTaskIndex;
                            slotRowIndex = 0;
                            colIndex = firstRowTaskIndex;
                        } else {
                            const secondRowItems = bookedParkingSlots.slice(halfIndex);
                            const secondRowTaskIndex = secondRowItems.findIndex(item => {
                                if (item.task) {
                                    return item.task.BOOKINGTASKID === task.BOOKINGTASKID;
                                } else {
                                    return item.booking.BOOKINGTASKS?.some(t => t.BOOKINGTASKID === task.BOOKINGTASKID);
                                }
                            });

                            if (secondRowTaskIndex !== -1) {
                                displayedIndex = halfIndex + secondRowTaskIndex;
                                slotRowIndex = 1;
                                colIndex = secondRowTaskIndex;
                            }
                        }
                    }

                    if (displayedIndex === -1) {
                        const allParkingSlots = yardPositions.filter(p => p.LOCATIONTYPE === 2);
                        const parkingIndex = allParkingSlots.findIndex(p => p.LOCATIONID === parkingSlot.LOCATIONID);
                        const slotsPerRow = Math.ceil(allParkingSlots.length / 2);
                        slotRowIndex = Math.floor(parkingIndex / slotsPerRow);
                        colIndex = parkingIndex % slotsPerRow;
                    }

                    const containerWidth = document.querySelector('.main-container')?.offsetWidth || 1200;
                    const containerHeight = document.querySelector('.main-container')?.offsetHeight || 800;
                    const parkingWrapperLeft = containerWidth * 0.08;
                    const parkingWrapperTop = containerHeight * 0.40;
                    const slotWidth = 115;
                    const slotHeight = 39;
                    let slotX, slotY;

                    const parkingSlotWrappers = document.querySelectorAll('.parking-slots-wrapper .parking-row');
                    let foundElement = false;

                    if (parkingSlotWrappers.length > 0 && displayedIndex !== -1) {
                        parkingSlotWrappers.forEach((row, rowIdx) => {
                            if (foundElement) return;

                            const slots = row.querySelectorAll('[class*="parking-slot"]');
                            slots.forEach((slot, slotIdx) => {
                                if (foundElement) return;
                                if (rowIdx === slotRowIndex && slotIdx === colIndex) {
                                    const slotRect = slot.getBoundingClientRect();
                                    const containerRect = document.querySelector('.main-container')?.getBoundingClientRect();

                                    if (containerRect) {
                                        slotX = slotRect.left - containerRect.left + (slotRect.width / 2);
                                        slotY = slotRect.top - containerRect.top + (slotRect.height / 2);
                                        foundElement = true;
                                    }
                                }
                            });
                        });
                    }

                    if (!foundElement) {
                        if (displayedIndex !== -1) {
                            if (slotRowIndex === 0) {
                                slotX = parkingWrapperLeft + (colIndex * slotWidth) + (slotWidth / 2);
                                slotY = parkingWrapperTop + (slotHeight / 2);
                            } else {
                                slotX = parkingWrapperLeft + (colIndex * slotWidth) + (slotWidth / 2);
                                slotY = parkingWrapperTop + slotHeight + (slotHeight / 2);
                            }
                        } else {
                            const allParkingSlots = yardPositions.filter(p => p.LOCATIONTYPE === 2);
                            const parkingIndex = allParkingSlots.findIndex(p => p.LOCATIONID === parkingSlot.LOCATIONID);
                            const slotsPerRow = Math.ceil(allParkingSlots.length / 2);
                            const fallbackRowIndex = Math.floor(parkingIndex / slotsPerRow);
                            const fallbackColIndex = parkingIndex % slotsPerRow;

                            slotX = parkingWrapperLeft + (fallbackColIndex * slotWidth) + (slotWidth / 2);
                            slotY = parkingWrapperTop + (fallbackRowIndex * slotHeight) + (slotHeight / 2);
                        }
                    }

                    // Get ramp position
                    const allRamps = yardPositions.filter(ramp => ramp.LOCATIONTYPE === 3);
                    const rampsPerRow = calculateRampsPerRow();
                    const rampIndex = allRamps.findIndex(r => r.LOCATIONID === targetRamp.LOCATIONID);
                    const isSecondRow = rampIndex >= rampsPerRow;
                    const rowIndex = isSecondRow ? rampIndex - rampsPerRow : rampIndex;

                    const containerRect = document.querySelector('.main-container')?.getBoundingClientRect();
                    let rampX, rampY;
                    let foundRamp = false;

                    if (containerRect) {
                        const rampRows = document.querySelectorAll('.ramp-row, .ramp-row2');
                        rampRows.forEach((row, rowIdx) => {
                            if (foundRamp) return;
                            const ramps = row.querySelectorAll('[class*="ramp-"]');

                            ramps.forEach((rampElement, idx) => {
                                if (foundRamp) return;
                                const currentRampIndex = rowIdx === 0 ? idx : rampsPerRow + idx;
                                if (currentRampIndex === rampIndex) {
                                    const rampRect = rampElement.getBoundingClientRect();

                                    rampX = rampRect.left - containerRect.left + (rampRect.width / 2);
                                    rampY = rampRect.top - containerRect.top + (rampRect.height / 2);
                                    foundRamp = true;
                                }
                            });
                        });
                    }

                    if (!foundRamp) {
                        const rampWidth = 29;
                        const rampGap = 4;
                        const concreteElement = document.querySelector('.concrete-under-the-ramps');
                        let rampStartLeft = 10;

                        if (concreteElement && containerRect) {
                            const concreteRect = concreteElement.getBoundingClientRect();
                            rampStartLeft = concreteRect.left - containerRect.left + 8;
                        }

                        rampX = rampStartLeft + (rowIndex * (rampWidth + rampGap)) + (rampWidth / 2);
                        rampY = isSecondRow ? (containerHeight * 0.896) + (30 / 2) : (containerHeight * 0.104) + (30 / 2);
                    }

                    // Build path points based on routing logic
                    let pathPoints = [];

                    if (slotRowIndex === 0 && isSecondRow) {
                        // Upper parking to LOWER ramps - route with corners (UP → LEFT → DOWN)
                        const topY = containerHeight * 0.29;
                        const leftX = containerWidth * 0.08;

                        pathPoints.push(`${slotX},${slotY}`);
                        pathPoints.push(`${slotX},${topY}`);
                        pathPoints.push(`${leftX - 20},${topY}`);

                        const safeBottomY = containerHeight * 0.70;
                        pathPoints.push(`${leftX - 20},${safeBottomY}`);
                        pathPoints.push(`${rampX},${safeBottomY}`);
                        pathPoints.push(`${rampX},${rampY - 25}`);

                    } else if (slotRowIndex === 0 && !isSecondRow) {
                        // Upper parking to UPPER ramps - simple direct route
                        pathPoints.push(`${slotX},${slotY}`);

                        const safeTopY = containerHeight * 0.30;
                        pathPoints.push(`${slotX},${safeTopY}`);
                        pathPoints.push(`${rampX},${safeTopY}`);
                        pathPoints.push(`${rampX},${rampY}`);

                    } else if (slotRowIndex === 1 && !isSecondRow) {
                        // Lower parking (half) to UPPER ramps - route with corners (DOWN → LEFT → UP)
                        const bottomY = containerHeight * 0.71;
                        const leftX = containerWidth * 0.08;

                        pathPoints.push(`${slotX},${slotY}`);
                        pathPoints.push(`${slotX},${bottomY}`);
                        pathPoints.push(`${leftX - 20},${bottomY}`);

                        const safeTopY = containerHeight * 0.30;
                        pathPoints.push(`${leftX - 20},${safeTopY}`);
                        pathPoints.push(`${rampX},${safeTopY}`);
                        pathPoints.push(`${rampX},${rampY}`);

                    } else {
                        // Lower parking to LOWER ramps - simple direct route
                        pathPoints.push(`${slotX},${slotY}`);

                        const safeBottomY = containerHeight * 0.70;
                        pathPoints.push(`${slotX},${safeBottomY}`);
                        pathPoints.push(`${rampX},${safeBottomY}`);
                        pathPoints.push(`${rampX},${rampY - 25}`);
                    }

                    const pathId = `path-${task.BOOKINGTASKID}`;

                    lines.push(
                        <polyline
                            key={pathId}
                            id={pathId}
                            points={pathPoints.join(' ')}
                            fill="none"
                            stroke="#14ae5c86"
                            strokeWidth="10"
                            strokeDasharray="11"
                            opacity="0.8"
                            strokeLinejoin="round"
                            strokeLinecap="round"
                            className="connecting-line-animation"
                        />
                    );

                    const animationPath = pathPoints.map((point, index) => {
                        return index === 0 ? `M${point}` : `L${point}`;
                    }).join(' ');

                    lines.push(
                        <polygon
                            key={`moving-arrow-${task.BOOKINGTASKID}`}
                            points="-8,-6 0,0 -8,6 -6,0"
                            fill="#4bff9fff"
                            opacity="1"
                            className="moving-arrow-animation"
                        >
                            <animateMotion
                                dur="12.5s"
                                repeatCount="indefinite"
                                rotate="auto"
                                path={animationPath}
                            />
                        </polygon>
                    );

                  
                    lines.push(
                        <circle
                            key={`marker-${task.BOOKINGTASKID}`}
                            cx={slotX}
                            cy={slotY}
                            r="4"
                            fill="#14ae5c86"
                            opacity="1"
                        />
                    );
                }
            }
        });
    });

    return (
        <svg
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 5
            }}
        >
            {lines}
        </svg>
    );
};

export default ConnectionLines;
